import React from "react";
import MyAccount from "../../views/clientView/myAccount";

export default function MyAccountClientPage() {
    return <MyAccount />
}